<template>
  <ul>
    <li v-for="(email, i) in emails" :key="i">
      <span v-if="email.email">{{email.email}}</span>
      <span v-else>{{email}}</span>
      <v-btn icon class="mx-0" @click="deleteItem(email)">
        <v-icon color="pink">delete</v-icon>
      </v-btn>
    </li>
  </ul>
</template>
<script>
export default {
  name: "list-emails",
  props: ["emails"],
  methods: {
    deleteItem: function(item) {
      this.$emit("deleteEmail", item);
    }
  }
};
</script>